import { DefaultRouteTabs, Group } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Alert, Button, Divider } from 'antd';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import InvoiceInstallmentNFSETable from '@/components/Fiscal/Invoice/NfsInstallments/InvoiceInstallmentNFSETable';
import NfsInstallmentModalForm from '@/components/Fiscal/Invoice/NfsInstallments/NfsInstallmentModalForm';
import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';

export default function InvoiceNfsInstallmentsPage({ route }: PageProps) {
  const {
    invoiceId,
    invoice: { data: invoice },
  } = useInvoiceFormContext();

  const [modalCreateInstallmentOpened, modalCreateInstallmentAction] =
    useDisclosure();

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  const disabledFields = invoice?.situation !== InvoiceSituation.IN_TYPING;

  return (
    <>
      <DefaultRouteTabs
        route={invoiceValidateRoutes(route, invoice?.situation)}
        baseKey={invoiceId}
        basePath={URL}
        permissions={route.permissions}
      >
        <Helmet title="Parcelas" />

        <Group position="between">
          <div>
            <Alert
              type="warning"
              message="Aba utilizada somente para os seguintes provedores: BARUERISP, BETHA, INFISC, IPM, PUBLICA, SIL."
              showIcon
              closable
            />
          </div>
          <div>
            <SpaceForButton justifyContent="end">
              <Button
                type="primary"
                onClick={modalCreateInstallmentAction.open}
                disabled={disabledFields}
              >
                Nova Parcela
              </Button>
            </SpaceForButton>
          </div>
        </Group>

        <Divider />

        <InvoiceInstallmentNFSETable
          invoiceId={Number(invoiceId)}
          disabledFields={disabledFields}
        />

        <Divider />

        <InvoiceButtonsRepeated />
      </DefaultRouteTabs>

      <NfsInstallmentModalForm
        open={modalCreateInstallmentOpened}
        onCancel={modalCreateInstallmentAction.close}
        onOk={() => null}
        invoiceId={Number(invoiceId)}
      />
    </>
  );
}
